import { render } from "./Buttons.vue?vue&type=template&id=26ee4664"
import script from "./Buttons.vue?vue&type=script&lang=js"
export * from "./Buttons.vue?vue&type=script&lang=js"
script.render = render

export default script